<template>
  <div class="common-alarm-bg">
    <div class="common-alarm-div" ref="fatigueDriverAlarm">
      <el-form
        :model="dataInfo"
        ref="form"
        :rules="dataInfoRules"
        label-width="80px"
      >
        <table class="alarm-table">
          <colgroup>
            <col style="width: 5%" />
            <col style="width: 30%" />
            <col style="width: 65%" />
          </colgroup>
          <tr>
            <td colspan="3">
              <el-tag type="warning"
                ><i class="el-icon-warning"></i
                >&nbsp;&nbsp;&nbsp;车辆连续驾驶超过设置时间，产生疲劳驾驶报警。按照规定停车休息后，报警自动解除。
              </el-tag>
            </td>
          </tr>
          <tr>
            <td>
              <p>是否启用</p>
            </td>
            <td>
              <el-form-item>
                <el-radio-group
                  v-model="dataInfo.alarmCommonAlarmSet.isApply"
                  @change="isApplyChange"
                >
                  <el-radio :label="radioLabel1">是</el-radio>
                  <el-radio :label="radioLabel0">否</el-radio>
                </el-radio-group>
              </el-form-item>
            </td>
            <td>
              <p>设置启用为“否”，该项报警设置暂时无效，直到重新启用。</p>
            </td>
          </tr>
          <tr>
            <td>
              <p>连续驾驶时长</p>
            </td>
            <td>
              <el-form-item prop="dayContinuousDrivingTime">
                <el-input
                  v-model="dataInfo.dayContinuousDrivingTime"
                  size="small"
                  class="alarm-form-input"
                  :disabled="disabledByApply"
                >
                  <template slot="append">小时</template>
                </el-input>
              </el-form-item>
            </td>
            <td>
              <p>
                连续驾驶时长，达到所设时长后报警为疲劳1级，之后每增加1小时，疲劳等级升高1级（疲劳等级最高为4级）。
              </p>
            </td>
          </tr>
          <tr>
            <td>
              <p>规定休息时间</p>
            </td>
            <td>
              <el-form-item prop="resetTime">
                <el-input
                  v-model="dataInfo.resetTime"
                  size="small"
                  class="alarm-form-input"
                  :disabled="disabledByApply"
                >
                  <template slot="append">分钟</template>
                </el-input>
              </el-form-item>
            </td>
            <td></td>
          </tr>
          <tr>
            <td>
              <p>适用范围</p>
            </td>
            <td>
              <el-form-item>
                <el-radio-group
                  v-model="dataInfo.alarmCommonAlarmSet.isOverAll"
                  :disabled="alarmSetId == 0 ? false : true"
                >
                  <el-radio :label="radioLabel1">全局设置</el-radio>
                  <el-radio :label="radioLabel0">自定义车辆</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item v-if="alarmSetId == 0">
                <e6Select
                  :dataList="vehicleTreeList"
                  :filterable="true"
                  slotTemplate="tree"
                  :issingleleaf="true"
                  multiple
                  ref="e6select"
                  :disabled="
                    dataInfo.alarmCommonAlarmSet.isOverAll == 1 ? true : false
                  "
                  :placeholder="'请选择车辆'"
                >
                </e6Select>
              </el-form-item>
              <el-form-item v-if="alarmSetId != 0">
                <el-input
                  v-model="dataInfo.vehicleNo"
                  size="small"
                  class="alarm-form-input"
                  :disabled="true"
                />
              </el-form-item>
            </td>
            <td>
              <p>
                对指定车辆自定义设置，选择的车辆按照所设置参数进行报警业务判断。若车辆某项报警进行了自定义设置，全局设置参数针对此车不起作用。
              </p>
            </td>
          </tr>
          <tr>
            <td colspan="3">
              <el-button type="text" @click="switchSetting">
                <i
                  :class="[
                    advancedSettingShow
                      ? 'el-icon-arrow-up'
                      : 'el-icon-arrow-down'
                  ]"
                ></i
                >{{ switchSettingBtnText }}
              </el-button>
            </td>
          </tr>
        </table>

        <table v-show="advancedSettingShow" class="alarm-table">
          <colgroup>
            <col style="width: 5%" />
            <col style="width: 30%" />
            <col style="width: 65%" />
          </colgroup>
          <tr>
            <td>
              <p>特殊时间段</p>
            </td>
            <td>
              <el-form-item>
                <el-radio-group
                  v-model="dataInfo.isSpecialTimeAlarm"
                  :disabled="disabledByApply"
                >
                  <el-radio :label="radioLabel1">启用</el-radio>
                  <el-radio :label="radioLabel0">不启用</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item>
                <span>开始时间：</span>
                <el-time-picker
                  v-model="dataInfo.bTimePoint"
                  size="small"
                  value-format="HH:mm:ss"
                  :picker-options="{
                    selectableRange: '00:00:00 - 23:59:59',
                    format: 'HH:mm:ss'
                  }"
                  placeholder="请输入或选择"
                ></el-time-picker>
              </el-form-item>
              <el-form-item>
                <span>结束时间：</span>
                <el-time-picker
                  v-model="dataInfo.eTimePoint"
                  size="small"
                  value-format="HH:mm:ss"
                  :picker-options="{
                    selectableRange: '00:00:00 - 23:59:59',
                    format: 'HH:mm:ss'
                  }"
                  placeholder="请输入或选择"
                ></el-time-picker>
              </el-form-item>
              <el-form-item prop="nightContinuousDrivingTime">
                <el-input
                  v-model="dataInfo.nightContinuousDrivingTime"
                  size="small"
                  class="alarm-form-input"
                  :disabled="disabledByApply"
                >
                  <template slot="prepend">行驶时长</template>
                  <template slot="append">小时</template>
                </el-input>
              </el-form-item>
            </td>
            <td>
              <p>例如夜间行驶，允许连续行驶时长可与白天不同</p>
            </td>
          </tr>
          <!-- <tr>
            <td>
              <p>平台显示</p>
            </td>
            <td>
              <el-form-item>
                <el-radio-group
                  v-model="dataInfo.alarmCommonAlarmSet.isPlateformShow"
                  :disabled="disabledByApply"
                >
                  <el-radio :label="radioLabel1">是</el-radio>
                  <el-radio :label="radioLabel0">否</el-radio>
                </el-radio-group>
              </el-form-item>
            </td>
            <td>
              <p>
                设置平台显示为“否”，报警处理及报警报表中记录报警信息，但是报警提示框与车辆定位监控不显示发生的报警信息。
              </p>
            </td>
          </tr>
          <tr>
            <td>
              <p>警音提醒</p>
            </td>
            <td>
              <el-form-item>
                <el-radio-group
                  v-model="dataInfo.alarmCommonAlarmSet.isAlarmSound"
                  :disabled="disabledByApply"
                >
                  <el-radio :label="radioLabel1">是</el-radio>
                  <el-radio :label="radioLabel0">否</el-radio>
                </el-radio-group>
              </el-form-item>
            </td>
            <td>
              <p>
                设置警音提醒显示为“是”，当发生报警的时候，平台会有警音提醒。
              </p>
            </td>
          </tr>
          <tr>
            <td>
              <p>通知终端</p>
            </td>
            <td>
              <el-form-item>
                <el-radio-group
                  v-model="dataInfo.alarmCommonAlarmSet.isTerminalShow"
                  :disabled="disabledByApply"
                >
                  <el-radio :label="radioLabel1">是</el-radio>
                  <el-radio :label="radioLabel0">否</el-radio>
                </el-radio-group>
              </el-form-item>
            </td>
            <td>
              <p>
                若设置邮件提醒，当发生报警时将报警信息通过邮件方式发送给联系人。若您开通了短信提醒，设置短信提醒，当发生报警时将报警信息通过手机短信发送给联系人。若设置了微信通知，并且联系人绑定了微信号，当发生报警时将报警信息通过服务号发送给联系人。现在就去设置。
              </p>
            </td>
          </tr>
          <tr>
            <td>
              <p>闪拍</p>
            </td>
            <td>
              <el-form-item>
                <el-radio-group
                  v-model="dataInfo.alarmCommonAlarmSet.isPhoto"
                  :disabled="disabledByApply"
                >
                  <el-radio :label="radioLabel0">关闭</el-radio>
                  <el-radio :label="radioLabel1">开启-拍照</el-radio>
                  <el-radio :label="radioLabel2">开启-10s短视频</el-radio>
                </el-radio-group>
              </el-form-item>
            </td>
            <td>
              <p>
                若选择开启，发生报警时，可抓拍照片或录制10s短视频（需安装摄像头）。
              </p>
            </td>
          </tr> -->
        </table>
      </el-form>
    </div>
    <div class="common-alarm-btndiv">
      <el-button
        type="primary"
        class="g-submit-btn"
        @click="addData()"
        :loading="loadingState"
        >保存</el-button
      >
      <el-button @click="cancelSubmit()">取消</el-button>
    </div>
  </div>
</template>

<script>
import {
  FetchSaveFatigueDriverAlarmSet,
  FetchFindFatigueDriverAlarmById,
  FetchUpdateFatigueDriverAlarmSet
} from "@/api/alarmSet/commonAlarmSet";
import { FetchVehicleTree } from "@/api/base/vehicle";
import e6Select from "e6select";
import { validatorIntNum } from "@/utils/validate.js";
export default {
  name: "fatigueDriverAlarm",
  components: { e6Select },
  props: ["alarmSetId"],
  data() {
    return {
      loadingState: false,
      vehicleTreeList: [],
      advancedSettingShow: false,
      switchSettingBtnText: "打开高级设置",
      disabledByApply: false,
      dataInfo: {
        isSpecialTimeAlarm: 0,
        dayContinuousDrivingTime: "", // 连续驾驶时长
        resetTime: "", // 规定休息时间
        nightContinuousDrivingTime: "", // 特殊时间段行驶时长
        alarmCommonAlarmSet: {
          isOverAll: 1,
          isApply: 1,
          isPlateformShow: 0,
          isAlarmSound: 0,
          isTerminalShow: 0,
          isPhoto: 0
        }
      },
      dataInfoRules: {
        dayContinuousDrivingTime: [
          { validator: validatorIntNum, trigger: ["blur"], required: true },
          { max: 6, message: "不可超过6位", trigger: ["blur", "change"] }
        ],
        resetTime: [
          { validator: validatorIntNum, trigger: ["blur"], required: true },
          { max: 6, message: "不可超过6位", trigger: ["blur", "change"] }
        ],
        nightContinuousDrivingTime: [
          { validator: validatorIntNum, trigger: ["blur"], required: true },
          { max: 6, message: "不可超过6位", trigger: ["blur", "change"] }
        ]
      }
    };
  },
  methods: {
    //初始化车辆树
    initVehicleTree() {
      FetchVehicleTree()
        .then(response => {
          if (response.result && Array.isArray(response.result)) {
            this.vehicleTreeList = response.result;
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    //切换是否显示高级设置
    switchSetting() {
      this.advancedSettingShow = !this.advancedSettingShow;
      if (this.advancedSettingShow) {
        this.switchSettingBtnText = "收起高级设置";
      } else {
        this.switchSettingBtnText = "打开高级设置";
      }
    },
    //切换是否启用
    isApplyChange(value) {
      if (value === 1) {
        this.disabledByApply = false;
      } else {
        this.disabledByApply = true;
      }
    },
    /**
     * 保存疲劳驾驶报警设置
     */
    addData() {
      this.$refs.form.validate(valid => {
        if (!valid) {
          return false;
        }
        if (this.alarmSetId == 0) {
          //新增
          this.dataInfo.vehicleIdList = this.getVehicleIdListParam();
          this.FetchSaveFatigueDriverAlarmSet(this.dataInfo);
        } else {
          //修改
          this.FetchUpdateFatigueDriverAlarmSet(this.dataInfo);
        }
      });
    },
    //新增
    FetchSaveFatigueDriverAlarmSet(data) {
      this.loadingState = true;
      FetchSaveFatigueDriverAlarmSet(data)
        .then(response => {
          this.submitCallback(response);
        })
        .catch(error => {
          console.log(error);
          this.loadingState = false;
        });
    },
    //修改
    FetchUpdateFatigueDriverAlarmSet(data) {
      this.loadingState = true;
      FetchUpdateFatigueDriverAlarmSet(data)
        .then(response => {
          this.submitCallback(response);
        })
        .catch(error => {
          console.log(error);
          this.loadingState = false;
        });
    },
    // 新增、修改完成时的回调函数
    submitCallback(data) {
      let type = data.code === 1 ? "success" : "error";
      let message = data.message;
      this.$message({
        showClose: true,
        message: message,
        type: type,
        duration: 1000,
        onClose: () => {
          if (type === "success") {
            this.$router.push("/alarmSetCommonAlarmSetList");
          }
          this.loadingState = false;
        }
      });
    },
    //根据ID获取设置信息
    FetchFindFatigueDriverAlarmById(data) {
      FetchFindFatigueDriverAlarmById(data)
        .then(response => {
          if (response.result) {
            this.dataInfo = response.result;
            this.dataInfo.dayContinuousDrivingTime ||
            this.dataInfo.dayContinuousDrivingTime === 0
              ? (this.dataInfo.dayContinuousDrivingTime += "")
              : "";
            this.dataInfo.resetTime || this.dataInfo.resetTime === 0
              ? (this.dataInfo.resetTime += "")
              : "";
            this.dataInfo.nightContinuousDrivingTime ||
            this.dataInfo.nightContinuousDrivingTime === 0
              ? (this.dataInfo.nightContinuousDrivingTime += "")
              : "";
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    // 取消
    cancelSubmit() {
      this.$router.push("/alarmSetCommonAlarmSetList");
    },
    //获取选中车辆id
    getVehicleIdListParam() {
      let selected = this.$refs.e6select.getSelectValues();
      selected = selected.map(item => {
        return item.id;
      });
      return selected;
    }
  },
  computed: {
    radioLabel0() {
      return 0;
    },
    radioLabel1() {
      return 1;
    },
    radioLabel2() {
      return 2;
    }
  },
  mounted() {
    //初始化车辆树
    this.initVehicleTree();
    if (this.alarmSetId != 0) {
      //根据ID查询报警信息
      this.FetchFindFatigueDriverAlarmById({ alarmSetId: this.alarmSetId });
    }
  }
};
</script>

<style lang="scss" scoped>
/deep/ .base-select .sub-selected-value .sub-select-list {
  top: 30px !important;
}
</style>
